import {
  benefitTypesService,
  type BenefitType,
} from '@/services/benefit-types';
import { useQuery } from '@tanstack/react-query';

/**
 * Modalidades do PME (Vida em Grupo) — DataTable `BenefitType` do InsureMO.
 * O catálogo é praticamente estático; cache de 5 min.
 */
export function useBenefitTypes() {
  return useQuery<BenefitType[], Error>({
    queryKey: ['benefit-types'],
    queryFn: async () => {
      const response = await benefitTypesService.list();
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar tipos de benefício',
        );
      }
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
}
